import { render, staticRenderFns } from "./exportfoodwaste.vue?vue&type=template&id=0350053a"
import script from "./exportfoodwaste.vue?vue&type=script&lang=js"
export * from "./exportfoodwaste.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports